// Import current Livewire and AlpineJs
import { Livewire, Alpine } from '@/livewire';
import { baseName } from '../app/support/utils';
import { Alpine as AlpineNonWired, AlpineWired } from "@nolikein/types-livewire3";
export type LivewireDataRecord = Record<string, unknown>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LivewireMethodsRecord = Record<string, (...args: any) => any>;

type AlpineComponent<
    LivewireData extends LivewireDataRecord,
    LivewireMethods extends LivewireMethodsRecord
> = AlpineNonWired.AlpineComponent<object>
    | AlpineWired.AlpineComponent<object, LivewireData, LivewireMethods>;

type ModuleComponent = Record<string, unknown> & {
    default: {
        name: string
        component: (...args: Array<unknown>) => AlpineComponent<LivewireDataRecord, LivewireMethodsRecord>
    };
};

type ModuleMagic = { default: (...args: Array<unknown>) => (() => void) };

/**
 * Components
 * The component are dynamically imported and named as the Filename (without the .ts part)
 */
const componentModules = import.meta.glob('../app/components/alpinejs/**/*.ts', { eager: true }) as Record<string, ModuleComponent>;
Object.entries(componentModules).forEach(([, module]) => {
    if (is.object(module.default)) {
        // Check for two properties : name and component.
        // If any do not exists, just ignore the file, it may be a helper file for the component.
        if (
            Object.prototype.hasOwnProperty.call(module.default, 'name')
            && is.string(module.default.name)
            && Object.prototype.hasOwnProperty.call(module.default, 'component')
            && is.function(module.default.component)
        ) {
            Alpine.data(module.default.name, module.default.component);
        }
    }
});

/**
 * Magics
 * The component are dynamically imported and named as the Filename (without the .ts part)
 */
const magicModules = import.meta.glob('../app/magics/alpinejs/**/*.ts', { eager: true }) as Record<string, ModuleMagic>;
Object.entries(magicModules).forEach(([path, module]) => {
    if ('function' === typeof module.default) {
        const componentName = baseName(path);
        Alpine.magic(componentName, module.default);
    }
});

/**
 * Plugins
 */
import focus from '@alpinejs/focus';
import { ModalManagerFactory } from '../app/support/modal';
import is from '../app/support/is';
Alpine.plugin(focus);

// Final step - Do not publish Alpine to window bellow
Livewire.start();

window.modal = ModalManagerFactory;

export { Alpine, Livewire };
